export function tagLabel(label) {
  return '#' + label;
}
